import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "No more cold rehearsals",
    body: "Practising your pitch in the mirror doesn't cut it. SalesPit puts a real human across the table, every single time.",
  },
  {
    n: "02",
    title: "Reps you can actually feel",
    body: "Live video, real objections, real pressure. Build the muscle memory that only comes from real conversations.",
  },
  {
    n: "03",
    title: "Reps compound",
    body: "One call teaches a lesson. A hundred calls builds a killer. SalesPit makes it stupid-simple to stack real reps until the pitch is muscle memory.",
  },
];

export const Manifesto = () => {
  return (
    <section className="mx-auto max-w-7xl px-6 py-24">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-heading sticky top-28 text-3xl font-bold leading-tight tracking-tight text-white md:text-4xl"
          >
            Practice like you play.
            <span className="mt-4 block text-lg font-light text-zinc-500">
              The philosophy behind the pit.
            </span>
          </motion.h2>
        </div>

        <div className="lg:col-span-8 lg:border-l lg:border-white/10 lg:pl-12">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className="flex gap-6 border-b border-white/10 py-9 last:border-b-0"
            >
              <span className="font-heading text-xl font-black text-[#E52525]">
                {c.n}
              </span>
              <div>
                <h3 className="font-heading text-2xl font-semibold text-white">
                  {c.title}
                </h3>
                <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-zinc-400">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
